import { doPost } from "../../common/redux/ApiClient";

const baseUrl = process.env.REACT_APP_BASE_DOMAIN;;

export function postMobile3(queryParams) {
  return doPost(`${baseUrl}/Mobile3.ashx`, queryParams);
}

export function postMobileA1(queryParams) {
  return doPost(`${baseUrl}/MobileA1.ashx`, queryParams);
}
